module.exports = __webpack_public_path__ + "static/media/davos_slider_4.f75deb72.jpg";